import { Heart, Zap } from "lucide-react";

export const Header = () => (
  <header className="header" data-testid="header">
    <div className="header-left">
      <div className="logo-section">
        <Heart className="logo-icon" fill="#ff4757" />
        <div>
          <div className="logo-text">
            <span className="rescue">RESCUE</span>
            <span className="aid">AID</span>
          </div>
          <div className="logo-subtitle">Service Console V1.0</div>
        </div>
      </div>
    </div>
    <div className="header-right">
      <div className="system-status" data-testid="system-status">
        <span className="status-dot"></span>
        <span>SYSTEM ONLINE</span>
      </div>
      <div className="datetime" data-testid="datetime">
        <Zap size={14} className="bolt-icon" />
        <span>{new Date().toLocaleString()}</span>
      </div>
    </div>
  </header>
);
